<template>
  <div id="notifications-page" style="padding: 20px;">
    <div style="border: 1px solid red; width: 400px; padding: 10px; margin: 0 auto; color: red; font-weight: bold">CAUTION you are about to send push notifications to LIVE users</div>
    <div class="row">
      <label>Notification title (optional)</label>
      <input columns="30" rows="5" v-model="title">
    </div>
    <div class="row">
      <label>Notification content</label>
      <textarea columns="30" rows="5" v-model="text">Boo</textarea>
    </div>
    <div class="row">
      <label>Article Label</label>
      <input v-model="articleLabel" />
    </div>
    <div class="row">
      <label>Skill ID</label>
      <input v-model="skillId" />
    </div>
    <div class="row">
      <label>Country:</label>
      <select name="country" v-model="country">
        <option value="LT">Lithuania</option>
        <option value="PL">Poland</option>
      </select>
    </div>
    <div class="row">
      <label>Sound type:</label>
      Persistent (only mark for testing): <input type="checkbox" v-model="persistent" />
    </div>
    <h1 style="margin-top: 20px">Select Destination Users and Segments</h1>
    <div class="row">
      <label>Test user ID</label>
      <input v-model="userId" />
    </div>
    <div class="row">
      <label>All PROs:</label>
      <input type="checkbox" v-model="segments.pros" />
      <label>Business PROs:</label>
      <input type="checkbox" v-model="segments.businessPros" />
    </div>
    <div class="row">
      <label>No orders:</label>
      <input type="checkbox" v-model="segments.noOrder" />
      <label style="margin-left: 10px">One order:</label>
      <input type="checkbox" v-model="segments.oneOrder" />
      <label style="margin-left: 10px">Multi order:</label>
      <input type="checkbox" v-model="segments.multiOrder" />
    </div>
    <div class="row">
      <label>Exclude Referrals Owners:</label>
      <input type="checkbox" v-model="segments.excludePromoOwners" />
    </div>
    <div class="row">
      <label>Exclude Active Discount Owners:</label>
      <input type="checkbox" v-model="segments.excludeDiscountOwners" />
    </div>
    <div v-if="!inProgress">
      <button style="margin-top:20px;margin-right:50px" v-on:click="sendNotifications()">TEST SEND</button>
      <button style="margin-top:20px; background-color: red; color: white" v-on:click="sendNotifications(true)">SEND</button>
    </div>
    <div v-else style="margin-top: 20px">
      Notification sending is in progress, please monitor status via slack channel #notifications.
      Do not close this window until sending is done.
    </div>
  </div>
</template>

<style scoped lang="less">
label {
  margin-right: 20px;
}
.row {
  margin-top: 20px;
}
input {
  padding: 10px;
}
button {
  margin-top: 10px;
  border: 1px solid black;
  padding: 10px;
  cursor: pointer;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";

export default {
  name: "notifications",
  data: function() {
    return {
      text: null,
      userId: null,
      title: null,
      articleLabel: null,
      skillId: null,
      segments: {},
      inProgress: false,
      persistent: false,
      country: 'LT',
    };
  },
  methods: {
    sendNotifications(live) {
      if (live) {
        const confirmation = confirm(
            "Are you sure you want to notify LIVE users?" 
          );
        if (!confirmation) {
          return;
        }
      } else {
        const confirmation = confirm(
            "Confirm notifications dry run?" 
          );
        if (!confirmation) {
          return;
        }
      }
      api.sendNotifications({
        text: this.text,
        testUserId: this.userId,
        liveRun: live,
        persistent: this.persistent,
        title: this.title,
        segments: this.segments,
        country: this.country,
        articleLabel: this.articleLabel,
        skillId: this.skillId
      });
      if (live && Object.keys(this.segments).length > 0) {
        this.inProgress = true;
      }
    }
  },
  watch: {
  },
  created: async function() {
  }
};
</script>
